export default "__VITE_ASSET__UsvNKcyk__"